import {ThemeProvider} from '@primer/styled-react'
import {AnalyticsProvider} from '@github-ui/analytics-provider'
import type React from 'react'
import {useIsStafftools} from './hooks/use-is-stafftools'
import {PageErrorBoundary} from './components/PageErrorBoundary'
import {UpsellInfoProvider} from './contexts/UpsellInfoContext'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {SharedRoutePayload} from './types/rules-types'

const appName = 'repository-rulesets'
const category = 'repository-rulesets'
const metadata = {}

type AppProps = {
  children?: React.ReactNode
}

export function App({children}: AppProps) {
  const isStafftools = useIsStafftools()

  if (!isStafftools) {
    return <InnerApp>{children}</InnerApp>
  }
  return (
    <StafftoolsThemeWrapper>
      <InnerApp>{children}</InnerApp>
    </StafftoolsThemeWrapper>
  )
}

function InnerApp({children}: AppProps) {
  const {upsellInfo} = useRoutePayload<SharedRoutePayload>()
  return (
    <PageErrorBoundary>
      <AnalyticsProvider appName={appName} category={category} metadata={metadata}>
        <UpsellInfoProvider upsellInfo={upsellInfo}>{children}</UpsellInfoProvider>
      </AnalyticsProvider>
    </PageErrorBoundary>
  )
}

function StafftoolsThemeWrapper({children}: AppProps) {
  return <ThemeProvider colorMode="day">{children}</ThemeProvider>
}

try{ App.displayName ||= 'App' } catch {}
try{ InnerApp.displayName ||= 'InnerApp' } catch {}
try{ StafftoolsThemeWrapper.displayName ||= 'StafftoolsThemeWrapper' } catch {}